import Form from 'react-bootstrap/Form';

const REPAYMENT_MODE_FILTER = {
  NEXT_PAYDAY: 'Next Payday',
  'FORCE,IMMEDIATE': 'Force/Immediate',
  CUSTOM: 'Custom',
  MANUAL: 'Manual',
  REPAID: 'Repaid',
};

function FundingsRepaymentModeForm({ modeFilter, changeModeFilter, spinner }) {
  return (
    <Form.Select
      className="bo-filter"
      name="modeFilter"
      id="modeFilter"
      disabled={spinner}
      value={modeFilter}
      onChange={e => changeModeFilter('fundings', e)}
    >
      <option value=""> All Repayments Mode</option>
      {Object.entries(REPAYMENT_MODE_FILTER).map(([key, value]) => (
        <option key={key} value={key}>
          {value}
        </option>
      ))}
    </Form.Select>
  );
}

export default FundingsRepaymentModeForm;
